import getUncompletedSections from './getUncompletedSections';
import {isDemandPreparing} from "./getDemandStatus";
import {previewDemandPublicFormDisabled} from "./getDemandStatus";

export default (demandValidation) => {
    if (!demandValidation || !isDemandPreparing() || previewDemandPublicFormDisabled()) return false;
    const uncompleted = getUncompletedSections(demandValidation);
    return uncompleted.length === 0;
}
